import * as React from "react";
import { useAuth } from "../contexts/authContext";
import { useSession } from "../contexts/sessionContext";
import { useAudit } from "../contexts/auditSessionContext";
import NamedRangeReader from "../components/NamedRangeReader";
import { Navigate } from "react-router-dom";
import { Button, PopoverSurface, PopoverTrigger, Spinner } from "@fluentui/react-components";
import { Popover } from "@fluentui/react-components";
import { MoreVertical20Regular } from "@fluentui/react-icons";

const Taskpane: React.FC = () => {
  const { auth, setAuth, loading: authLoading } = useAuth();
  const { sessionAttachment } = useSession();
  const { fetchAuditSession, auditSession, loading: auditSessionLoading } = useAudit();
  React.useEffect(() => {
    if (sessionAttachment) {
      fetchAuditSession({ auditSessionId: sessionAttachment.sessionId });
    }
  }, [sessionAttachment]);
  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("workspace_id");
    localStorage.removeItem("id_token");
    setAuth({
      user: null,
      loading: false,
      accessToken: null,
      workspace: null,
    });
  };

  if (!auth.user && !authLoading) {
    console.log("taskpane auth navigate to signin");
    return <Navigate to="/signin" />;
  }

  if (!auditSession && !auditSessionLoading) {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <div className="flex flex-col items-center p-4 text-center">
          <p className="text-lg font-bold">No audit session found</p>
          <p className="text-sm text-gray-500 mb-4">Please download a workbook from midship.ai to get started</p>
          <Button appearance="outline" onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </div>
    );
  }

  if (auditSessionLoading) {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="w-full h-screen">
      {/* popover with logout button */}
      <Popover>
        <div className="flex justify-end px-4 py-2 mr-5">
          <PopoverTrigger>
            <MoreVertical20Regular />
          </PopoverTrigger>
        </div>
        <PopoverSurface>
          <Button appearance="outline" onClick={handleLogout}>
            Logout
          </Button>
        </PopoverSurface>
      </Popover>
      <div className="space-y-4">
        {/* <NamedRangeAdder /> */}
        {auditSession && <NamedRangeReader />}
      </div>
    </div>
  );
};

export default Taskpane;
